import { render, staticRenderFns } from "./IngresoDimensiones.vue?vue&type=template&id=8a8fb6d0&"
import script from "./IngresoDimensiones.vue?vue&type=script&lang=js&"
export * from "./IngresoDimensiones.vue?vue&type=script&lang=js&"
import style0 from "./IngresoDimensiones.vue?vue&type=style&index=0&id=8a8fb6d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports